import styleInject from '../../external/style-inject/dist/style-inject.es.js';

var css_248z = ".Breadcrumb-module_breadcrumb__ate58 {\n  color: #6f757c;\n}\n.Breadcrumb-module_breadcrumb__ate58 svg {\n  margin-right: 8px;\n  color: #6f757c;\n}\n.Breadcrumb-module_breadcrumb__ate58 *,\n.Breadcrumb-module_breadcrumb__ate58 a:link,\n.Breadcrumb-module_breadcrumb__ate58 a:visited,\n.Breadcrumb-module_breadcrumb__ate58 a:hover,\n.Breadcrumb-module_breadcrumb__ate58 a:active {\n  font-size: 0.875rem;\n  line-height: 1.42;\n  color: #6f757c;\n}";
var styles = {"breadcrumb":"Breadcrumb-module_breadcrumb__ate58"};
styleInject(css_248z);

export { styles as default };
